module.exports = __webpack_public_path__ + "img/logo_acuerdo.08418e0d.png";